import { Bike, CarTaxiFront, Truck } from "lucide-react";
// Custom service glyphs rendered as CSS masks so they follow `currentColor` like lucide icons.
const maskIcon = (src) => {
  const Icon = ({ size = 24, className = "", style }) => (
    <span
      aria-hidden="true"
      className={`inline-block shrink-0 bg-current ${className}`}
      style={{
        width: size, height: size,
        WebkitMask: `url(${src}) center / contain no-repeat`,
        mask: `url(${src}) center / contain no-repeat`,
        ...style,
      }}
    />
  );
  return Icon;
};

// Outlined lidded bin — same geometry as the home-tile TrashCan so both apps match.
export const TrashBinIcon = ({ size = 24, className = "", style }) => (
  <svg viewBox="6 6 28 32" width={size} height={size} className={`inline-block shrink-0 ${className}`} style={style} fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10 15 L12 35 Q12.3 37 14.5 37 L25.5 37 Q27.7 37 28 35 L30 15 Z" />
    <path d="M16.5 20 V31 M23.5 20 V31" />
    <path d="M7 12.5 H33" />
    <path d="M16 12.5 V9.5 Q16 8 17.5 8 H22.5 Q24 8 24 9.5 V12.5" />
  </svg>
);
export const LaundryIcon = maskIcon("/icons/laundry.png");
export const RideTileIcon = maskIcon("/ride-tile-icon.png");
export const MotorTileIcon = maskIcon("/motor-tile-icon.png");
export const DeliveryTileIcon = maskIcon("/delivery-tile-icon.png");
export const RunnerTileIcon = maskIcon("/runner-tile-icon.png");

export const SERVICE_ICON = {
  ride: RideTileIcon, taxi: CarTaxiFront, motor: MotorTileIcon, tricycle: Bike, van: Truck,
  delivery: DeliveryTileIcon, laundry: LaundryIcon, trash: TrashBinIcon, runner: RunnerTileIcon,
};
